import { Component, HostListener, Input, OnDestroy, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import { Constant } from '../../../environments/constants';
import { Subscription } from 'rxjs';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';
import * as Highcharts from 'highcharts';
import addMore from "highcharts/highcharts-more";
import { Utils } from '../../../utils/utils';
import { RefDataService } from '../../services/context/ref-data.service';
addMore(Highcharts)

@Component({
  selector: 'gp-goal-expense',
  templateUrl: './goal-expense.component.html',
  styleUrls: ['./goal-expense.component.scss']
})
export class GoalExpenseComponent implements OnInit, OnChanges, OnDestroy {

  //dataSource;
  //displayedColumns: string[] = ['yr', 'portBeginBal', 'totIncome', 'portInc', 'totExpense', 'totTax', 'portTaxes', 'totSavings', 'netCashFlow', 'portEndBal'];
  
  @Input('GoalId') goalId: string;
  @Input('Refresh') refreshMe: boolean;
  
  protected _storeDataSubscription: Subscription;
  Highcharts: typeof Highcharts = Highcharts;
  options: Highcharts.Options;
  private chart: Highcharts.Chart;
  goalSummary;
  isDataAvailable = false;
  planResultViewBy = fromModel.PLANRESULTVIEWBY.PV;
  
  constructor(private dataService: DataService,
      private uiStateService: UIStateService,  
      private refDataService: RefDataService,
      private appMonitoringService: AppMonitoringService) {    
  }

  ngOnInit(): void {
    this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "GoalExpenseComponent-ngOnInit", true);
    this.populateGoalSummary();
    //this.dataService.getGoalSummary();
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
  }

  ngOnChanges(changes: SimpleChanges){
    if(this.refreshMe){
      //this.populateGoalSummary();
      //this.chart = null;
      // if(this.chart){
      //   let seriesLength = this.chart.series.length;
      //   for(var i = seriesLength - 1; i > -1; i--) {
      //     this.chart.series[i].remove();
      //   }
      // }
      this.refreshMe = false;
    }

  }

  private populateAppData(appData: fromModel.IAppData){
    //this.dataSource = null;
    if(appData && appData.action!==fromModel.DATA_ACTION.NONE){ 
      if(this.goalSummary && !this.goalSummary.Error){
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "GoalExpenseComponent-populateAppData", false);
      } else {
        if(appData.GoalSummary && appData.GoalSummary.length>0){
          this.populateGoalSummary();
        }
      } 
      
      // if(appData && (appData.action===fromModel.DATA_ACTION.UPDATEPLANRESULTVIEWBY)){        
      //   this.populateGoalSummary();
      // }

      if(appData && (appData.action===fromModel.DATA_ACTION.UPDATESETTINGS)){        
        this.populateGoalSummary();
        this.dataService.getPlanAnalysis(); 
      }
    }
  }

  // private populateAppData(appData: fromModel.IAppData){
  //   if(appData && appData.action!==fromModel.DATA_ACTION.NONE){
  //     this.populateGoalSummary();     
  //   }
  // }

  private populateGoalSummary(){
    let goal = this.dataService.getGoalByGoalId(this.goalId);
    if(goal && goal.expenses && goal.expenses.length>0){
      this.goalSummary = this.dataService.getGoalSummaryByGoalId(this.goalId);
      if(this.goalSummary && this.goalSummary.Error){
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG, "GoalExpenseComponent-populateAppData - Error", {ShowMsg: true,  MsgType: fromModel.MSGTYPE.ERROR, Msg: Constant.ErrorMsgs.analyticErrorMsg});
      } else {
        this.setChartOptionsData();
        this.isDataAvailable = true;
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "GoalExpenseComponent-populateAppData", false);
      }
    }  
  }

  private setChartOptionsData(){
    this.options = {
      chart: {
        type: 'column',
        style: {
          fontSize: '18'
        } 
    },
    title: {
        text: ''
    },
    subtitle: {
      text: ''
    },
    credits: {
      enabled: false
    },
    xAxis: {
      title: {              
        text: '',
        style: {
          fontSize: '16'
        }
      },
      labels: {
        style: {            
            fontSize:'14'
        }
      },
      type: 'datetime',
      startOnTick: true,
      // endOnTick: true,
      // showLastLabel: false,
      // labels: {
      //   enabled: false,
      //   style: {                
      //     fontSize: '16'
      //   }
      // },
      // showFirstLabel: true,            
      tickInterval: 1000 * 60 * 60 * 24 * 1825,  
      //tickWidth: 0,
      // tickInterval: 12,
      //allowDecimals: false,
      //min: 0
      //plotLines: [],
    },
    yAxis: {
      title: {
          text: 'Cost ($)',
          style: {
            fontSize: '16'
          }
      },          
      labels: {
        style: {                
            fontSize: '16'
        }
      },
      lineWidth: 0,
      //tickInterval: 2,
      allowDecimals: false,
      //min: 0          
    },
    legend: {
      enabled: true, 
      itemStyle:{
        fontSize: '14'
      }      
    },
    // tooltip: {
    //     headerFormat: '<b>{point.x}</b><br/>',
    //     pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
    // },
    tooltip: {
      shared:true,
      useHTML: true,
      style:{
        color: '#4F528C', 
        fontSize: '14',
        fontFamily: 'Avenir',
        fontWeight: 'bold'
      },
      formatter: function(){
        //console.log(this.points);
        var formatStr = "";          
        if(this.points && this.points.length>0){
          formatStr += '<div class="font16">' + Highcharts.dateFormat('%Y',this.points[0].x) + '</div>';
          var ageSeries = this.points.find(point=>point.series.name === fromModel.CHARTSERIESNAME.Age);
          if(ageSeries){
            var data = ageSeries.series.data.find(data=>data.x === ageSeries.x);
            if(data){
              formatStr += '<span class="font14 pClient">' + data['pName'] + ': <span class="font12">age</span> ' + data['pAge'] + '</span>'; 
              if(data['sDisplayName']){
                formatStr += ' | <span class="font14 sClient">' + data['sName'] + ': <span class="font12">age</span> ' + data['sAge'] + '</span>'; 
              } 
              formatStr += '</br></br>';              
            }
          }                      
          formatStr +=  '<table style="width: 100%">';
          for (var i = 0; i < this.points.length; i++) {
            var point = this.points[i];
            if( point.series.name!==fromModel.CHARTSERIESNAME.Age){        
                formatStr += '<tr>';
                formatStr += '<td>';
                //formatStr += '<span class="font18 m-r5" style="color:' + point.color + '">●</span>';                  
                formatStr += '<span class="m-r5"><svg width="10" height="10"><circle cx="5" cy="5" r="5" fill="' + point.color + '" /></svg></span>';                
                formatStr += point.series.name;
                formatStr += '</td>';
                formatStr += '<td style="text-align: right; padding-left:50px"><b> $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b></td>'; 
                formatStr += '</tr>';
            }
          }
          formatStr += '</table>';               
        }
        return formatStr;
      },
     },
    plotOptions: {
        column: {
            stacking: 'normal',
            dataLabels: {
                enabled: false
            }
        }      
    },
    series: []
      // series: [{
      //     name: 'John',
      //     data: [5, 3, 4, 7, 2]
      // }, {
      //     name: 'Jane',
      //     data: [2, 2, 3, 2, 1]
      // }, {
      //     name: 'Joe',
      //     data: [3, 4, 4, 2, 5]
      // }] 

    }; 

    let { series } = this.options;
    // if(this.chart){
    //   let seriesLength = this.chart.series.length;
    //     for(var i = seriesLength - 1; i > -1; i--) {
    //       this.chart.series[i].remove();
    //     }
    //   }
    series = this.getChartData(series);
    this.options = {...this.options, series};   
    // if(this.chart) {
    //   this.chart.redraw();
    // }
    // let { xAxis } = this.options;
    // xAxis = this.getChartXPlotLine(xAxis);
    // this.options = {...this.options, xAxis}; 
  }

  private getChartData(series){
    let data = [];
    this.planResultViewBy = this.dataService.getPlanresultViewBy();  
    //let _allExp = this.dataService.getAllExpenses();
    //let expListRef = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Expenses);
    let _exp: fromModel.Expense;
    if(this.goalSummary && this.goalSummary.GoalSummary && this.goalSummary.GoalSummary
      && this.goalSummary.GoalSummary.expYoy
      && this.goalSummary.GoalSummary.expYoy.length>0){
        this.goalSummary.GoalSummary.expYoy.forEach(cashFlow => {
          if(cashFlow){
              data = [];
              _exp = this.dataService.getExpenseByExpenseId(cashFlow.expId);
              if(cashFlow.yoy){
                var cfYoy = Object.keys(cashFlow.yoy);
                cfYoy.forEach(yr => {
                  let displayDate = Date.UTC(Number(yr), 0, 1);
                  if(this.planResultViewBy === fromModel.PLANRESULTVIEWBY.FV){
                    let _d = {x: displayDate, y: cashFlow.yoy[yr].fv, expId: _exp.expId, expType: _exp.expType, expDesc: _exp.expDesc};
                    data.push(_d);   
                  } else {
                    let _d = {x: displayDate, y: cashFlow.yoy[yr].pv, expId: _exp.expId, expType: _exp.expType, expDesc: _exp.expDesc};
                    data.push(_d);   
                  }
                  
                });
              }
              series.push({name: _exp.expDesc, type: 'column', data: data});
          }
        });
        
        // let _seriesData;
        // expListRef.forEach(expRef => {
        //   _seriesData = data.filter(({expType}) => expType === expRef.code);          
        //   if(_seriesData && _seriesData.length>0){
        //     series.push({name: _seriesData[0].expDesc, type: 'column', data: _seriesData});
        //   }          
        // });
      
    }
      series.push(this.dataService.getChartSeries({chartSeriesType: fromModel.CHARTSERIESTYPE.AGE}).series[0]);
      return series;
  }

  @HostListener('window:resize', ['$event'])
  onResize(){
    if(this.chart) {
      this.chart.reflow();
    }
  }

  public chartCallBack = (chart: Highcharts.Chart) => {
    this.chart =  chart;
    setTimeout(() => {
      if(this.chart && this.chart.hasOwnProperty('series')) {
        this.chart.reflow();
      }
    }, 300);
  }

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }    
    // if(this.chart) {
    //   this.chart = null;
    // }
  }


  // private populateAppData(appData: fromModel.IAppData){
  //   this.dataSource = null;
  //   if(appData && appData.action!==fromModel.DATA_ACTION.NONE && appData.action===fromModel.DATA_ACTION.GOALSUMMARY){   
  //     if(appData.GoalSummary && appData.GoalSummary.length>0){
  //       this.populateGoalSummary();
  //     }        
  //   }
  // }


  // private getChartData(series){
  //   let data = [];
    
  //   //let _allExp = this.dataService.getAllExpenses();
  //   let expListRef = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Expenses);
  //   let _exp: fromModel.Expense;
    
   
    
  //   if(this.goalSummary.GoalSummary && this.goalSummary.GoalSummary.goalSmry 
  //     && this.goalSummary.GoalSummary.goalSmry.length>0 
  //     && this.goalSummary.GoalSummary.goalSmry[0].expYoy
  //     && this.goalSummary.GoalSummary.goalSmry[0].expYoy.length>0){

  //       this.goalSummary.GoalSummary.goalSmry[0].expYoy.forEach(cashFlow => {
  //         if(cashFlow){
  //             data = [];
  //             _exp = this.dataService.getExpenseByExpenseId(cashFlow.expId);
  //             if(cashFlow.yoy){
  //               var cfYoy = Object.keys(cashFlow.yoy);
  //               cfYoy.forEach(yr => {
  //                 let displayDate = Date.UTC(Number(yr), 11, 31);     
  //                 let _d = {x: displayDate, y: cashFlow.yoy[yr].fv, expId: _exp.expId, expType: _exp.expType, expDesc: _exp.expDesc};
  //                 data.push(_d);   
  //               });
  //             }
  //             series.push({name: _exp.expDesc, type: 'column', data: data});
  //         }
  //       });
        
  //       // let _seriesData;
  //       // expListRef.forEach(expRef => {
  //       //   _seriesData = data.filter(({expType}) => expType === expRef.code);          
  //       //   if(_seriesData && _seriesData.length>0){
  //       //     series.push({name: _seriesData[0].expDesc, type: 'column', data: _seriesData});
  //       //   }          
  //       // });
      
  //   }
    
  //     return series;
  // }

  // private getChartData(series){
  //   let data = [];
    
  //   //let _allExp = this.dataService.getAllExpenses();
  //   let expListRef = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Expenses);
  //   let _exp: fromModel.Expense;
    
   
    
  //   if(this.goalSummary.GoalSummary && this.goalSummary.GoalSummary.yoyCashFlows 
  //     && this.goalSummary.GoalSummary.yoyCashFlows.length>0){

  //       this.goalSummary.GoalSummary.yoyCashFlows.forEach(cashFlow => {
  //         if(cashFlow && cashFlow.totExpenseIds && cashFlow.totExpenseIds.length>0){
  //           cashFlow.totExpenseIds.forEach(exp => {              
  //             _exp = this.dataService.getExpenseByExpenseId(exp.code);
  //             let displayDate = Date.UTC(cashFlow.yr, 11, 31);   

  //             let _d = {x: displayDate, y: exp.value, expId: _exp.expId, expType: _exp.expType, expDesc: _exp.expDesc};
  //             data.push(_d);
  //           });          
  //         }
  //       });
        
        
  //       let _seriesData;
  //       expListRef.forEach(expRef => {
  //         _seriesData = data.filter(({expType}) => expType === expRef.code);          
  //         if(_seriesData && _seriesData.length>0){
  //           series.push({name: _seriesData[0].expDesc, type: 'column', data: _seriesData});
  //         }          
  //       });
      
  //   }
    
  //   return series;
  // }


  // private getChartXPlotLine(xAxis) {

  //   let lastProjPoint;
  //   let tempDate;
  //   let month;
  //   let day;
  //   let year;
  //   let displayDate;

  //   let primaryClient = this.dataService.getClientByRole(fromModel.CLIENTROLE.Primary);
  //   month = 11;
  //   day = 31;
  //   year = Utils.getYearByAge(primaryClient.age, primaryClient.retAge);
  //   displayDate = Date.UTC(year, month, day);
  //   xAxis.plotLines.push({ color: '#a3a2a0', width: 2, dashStyle: "Dash", zIndex: 10, value: displayDate, label: {text: 'Retirement', align: 'top',  y: 0}});     

    

    
  //   return xAxis;
  // }


}


// formatter: function(){
//   var formatStr = "";
//   for (var i = 0; i < this.points.length; i++) {
//     var point = this.points[i];

//     if(i===0)
//     {
//       formatStr = "<b>" + Highcharts.dateFormat('%Y',point.x) + "</b><br/>";
//     }

//     if(point.series.name!=='Range'){
  
//     formatStr += '<span style="color:' + point.color + '">●</span> ' + point.series.name + '<b>: $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b><br/>';
//   }
//   }
//   return formatStr;
// },